"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _image = require("@site/pattern-library-core/image");
/**
 * Local Imports
 */

const LogoWrapper = /*#__PURE__*/(0, _react2.styled)("li")({
  name: "LogoWrapper",
  class: "pl-l1qbymb5"
});
const Image = /*#__PURE__*/(0, _react2.styled)(_image.LazyImage)({
  name: "Image",
  class: "pl-i2tzkf1"
});

/**
 * LogoItem Component.
 *
 * @param {Object} props React props
 * @param {Object} props.image Image Object for each Logo
 * @returns {React.ReactElement} LogoItem Component
 * @public
 */
function LogoItem({
  image = {}
}) {
  const {
    url,
    altText,
    height,
    width
  } = image;
  return /*#__PURE__*/_react.default.createElement(LogoWrapper, {
    "data-cy": "logo-wrapper"
  }, image && /*#__PURE__*/_react.default.createElement(Image, {
    url: url,
    altText: altText,
    height: height,
    width: width
  }));
}
var _default = exports.default = LogoItem;
LogoItem.propTypes = {
  image: _propTypes.default.object.isRequired
};